var map = {
	".": 45,
	"./": 45,
	"./Abstract": 75,
	"./Abstract.js": 75,
	"./App": 44,
	"./App.css": 202,
	"./App.js": 44,
	"./App.test": 117,
	"./App.test.js": 117,
	"./Authors": 74,
	"./Authors.js": 74,
	"./Figure": 76,
	"./Figure.js": 76,
	"./TeXTable": 168,
	"./TeXTable.js": 168,
	"./authorlist": 77,
	"./authorlist.js": 77,
	"./figures": 78,
	"./figures.js": 78,
	"./figures/Fig1.jpg": 486,
	"./figures/Fig2.jpg": 487,
	"./figures/Fig3.jpg": 488,
	"./figures/Fig4.jpg": 489,
	"./figures/Fig5.jpg": 490,
	"./index": 45,
	"./index.css": 116,
	"./index.js": 45,
	"./logo.svg": 491,
	"./metadata": 31,
	"./metadata.js": 31,
	"./reportWebVitals": 79,
	"./reportWebVitals.js": 79,
	"./setupTests": 169,
	"./setupTests.js": 169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 201;